let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1LSGb")).then(() => parcelRequire('9A2qf'));